const Theme = {
  body_background_color: '#007e86',
  title_font: 'Montserrat, sans-serif',
  title_weight: 700,
  title_color: '#008088',
  subtitle_color: '#7e7f7f',
  subtitle_weight: 600,
  title_margin_left: 7,
  text_font: 'Montserrat, sans-serif',
  text_weight: 400,
  logo_image_url: 'lorientagglo.png',
  header_margin_bottom: 20,
  token_hidden: true,
  number_hidden: true,
  header_full_height: true,
  header_no_margin: true,
  header_no_border: true,
  logo_full_width: true,
  button_border_width: 1,
  button_color: '#007e86',
  button_hover_text_color: '#007e86',
  button_radius: 50,
  button_outlined_border_color: '#007e86',
  button_outlined_hover_border_color: '#007e86'
}

export default Theme